<tour-step-template>
  <ng-template let-step="step">
    <m-card type="custom" class="tour-card" (click)="$event.stopPropagation()">
      <div class="tour-card__container">
        <div class="tour-card__header">
          <div class="tour-card__title">{{ step.title | mTranslate }}</div>
          <div class="tour-card__content">{{ step.content | mTranslate }}</div>
        </div>
        @if (steps$ | async; as steps) {
          @if (steps.length > 1) {
            <m-card-footer class="tour-card__footer">
              @if (step.showProgress) {
                <div class="tour-card__progress">{{ index$ | async }} / {{ steps.length }}</div>
              }
              <div class="tour-card__nav">
                @if (hasPrev(step)) {
                  <button m-button class="tour-card__btn" buttonType="ghost" [iconButton]="true" (click)="prev()">
                    <m-icon iconName="arrowLeftRegular" />
                  </button>
                }
                <button m-button class="tour-card__btn" buttonType="flat" [iconButton]="true" (click)="next(step)">
                  <m-icon iconName="arrowRightRegular" />
                </button>
              </div>
            </m-card-footer>
          }
        }
      </div>
    </m-card>
  </ng-template>
</tour-step-template>
